import { ApolloClient, ApolloLink } from "@apollo/client";
import { getEnvironment } from "@sail/utils";
import createDeduplicationLink from "../prefetching/createDeduplicationLink";
import createPrefetchLink from "../prefetching/createPrefetchLink";
import createRuntimePermissionsCheckLink from "../prefetching/createRuntimePermissionsCheckLink";
import { getApolloSharedCaches } from "../shared/apollo/getApolloSharedCaches";
import createCache from "../../public/graphql/createCache";
import createComponentKillswitchLink from "../../public/links/createComponentKillswitchLink";
import createDirectivesToContextLink from "../../public/links/createDirectivesToContextLink";
import createKillswitchLink from "../../public/links/createKillswitchLink";
import createObservabilityLink from "../../public/links/createObservabilityLink";
import createOverriddenV1ToV2Link from "../../public/links/createOverriddenV1ToV2Link";
import createTimeoutLink from "../../public/links/createTimeoutLink";
export const defaultOptions = {
    watchQuery: {
        fetchPolicy: 'cache-first'
    }
};
const createApolloCache = (graphqlConfig)=>{
    if (graphqlConfig.sharedCache && graphqlConfig.sharedCacheId) {
        throw new Error('Cannot specify both sharedCache and sharedCacheId');
    }
    if (graphqlConfig.sharedCache) {
        return graphqlConfig.sharedCache;
    }
    const sharedApolloCaches = getApolloSharedCaches();
    if (graphqlConfig.sharedCacheId) {
        const existingCache = sharedApolloCaches.get(graphqlConfig.sharedCacheId);
        if (existingCache) {
            return existingCache;
        }
    }
    const cache = createCache(graphqlConfig.schemas);
    if (graphqlConfig.sharedCacheId) {
        sharedApolloCaches.set(graphqlConfig.sharedCacheId, cache);
    }
    return cache;
};
function createApolloLink(graphqlConfig) {
    var _graphqlConfig_prefetch;
    return ApolloLink.from([
        createDirectivesToContextLink(),
        createObservabilityLink(),
        createTimeoutLink(),
        createRuntimePermissionsCheckLink(),
        createPrefetchLink((_graphqlConfig_prefetch = graphqlConfig.prefetch) !== null && _graphqlConfig_prefetch !== void 0 ? _graphqlConfig_prefetch : {}),
        createDeduplicationLink(),
        createKillswitchLink(),
        createComponentKillswitchLink(),
        createOverriddenV1ToV2Link(graphqlConfig)
    ]);
}
export const createApolloClient = (graphqlConfig)=>{
    return new ApolloClient({
        connectToDevTools: getEnvironment() === 'development',
        link: createApolloLink(graphqlConfig),
        cache: createApolloCache(graphqlConfig),
        defaultOptions,
        assumeImmutableResults: true,
        queryDeduplication: false
    });
};

//# sourceMappingURL=client.js.map